module.exports = __webpack_public_path__ + "static/img/E1.21583e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl/E1.png
// module id = gNsj
// module chunks = 0